// Talep gönderilmeden sayfadan çıkılırken taslak kaydetme sorusu
import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { Button } from '../../ui/button';
import {
  AlertDialog, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from '../../ui/alert-dialog';

const LEAVE_SELECTOR = 'a[href], [data-leave-target]';

export const useLeaveDraftGuard = (enabled, active) => {
  const navigate = useNavigate();
  const [target, setTarget] = useState(null);
  const activeRef = useRef(active);
  activeRef.current = active;

  useEffect(() => {
    if (!enabled) return undefined;
    const onClick = (e) => {
      if (!activeRef.current || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey) return;
      const el = e.target.closest(LEAVE_SELECTOR);
      if (!el || el.closest('[data-leave-guard-dialog]')) return;
      if (el.hasAttribute('download')) return;
      const dest = el.getAttribute('data-leave-target') || el.getAttribute('href');
      if (!dest || el.target === '_blank' || /^(https?:|mailto:|tel:|#|blob:|data:)/.test(dest)) return;
      e.preventDefault();
      e.stopPropagation();
      setTarget(dest);
    };
    const onPop = () => {
      if (!activeRef.current) return;
      window.history.pushState(null, '', window.location.href);
      setTarget('/work-permits');
    };
    const onUnload = (e) => {
      if (!activeRef.current) return;
      e.preventDefault();
      e.returnValue = '';
    };
    window.history.pushState(null, '', window.location.href);
    document.addEventListener('click', onClick, true);
    window.addEventListener('popstate', onPop);
    window.addEventListener('beforeunload', onUnload);
    return () => {
      document.removeEventListener('click', onClick, true);
      window.removeEventListener('popstate', onPop);
      window.removeEventListener('beforeunload', onUnload);
    };
  }, [enabled]);

  const leave = (dest = target) => {
    activeRef.current = false;
    setTarget(null);
    navigate(dest);
  };

  return { target, setTarget, cancel: () => setTarget(null), leave, disarm: () => { activeRef.current = false; } };
};

export const LeaveDraftDialog = ({ open, saving, onSave, onDiscard, onCancel }) => (
  <AlertDialog open={open} onOpenChange={(o) => !o && !saving && onCancel()}>
    <AlertDialogContent className="max-w-xl" data-leave-guard-dialog data-testid="wizard-leave-dialog">
      <AlertDialogHeader>
        <AlertDialogTitle>Talep gönderilmedi</AlertDialogTitle>
        <AlertDialogDescription>
          Talebinizi göndermeden çıkıyorsunuz, talebinizi taslak olarak kayıt etmek ister misiniz?
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter className="flex-wrap gap-2 sm:gap-2">
        <Button variant="ghost" onClick={onCancel} disabled={saving} data-testid="wizard-leave-cancel-btn">Vazgeç</Button>
        <Button variant="outline" onClick={onDiscard} disabled={saving} className="border-rose-200 text-rose-700 hover:bg-rose-50" data-testid="wizard-leave-discard-btn">Hayır, Kaydetmeden Çık</Button>
        <Button onClick={onSave} disabled={saving} className="bg-emerald-600 hover:bg-emerald-700" data-testid="wizard-leave-save-btn">
          {saving && <Loader2 className="h-4 w-4 mr-2 animate-spin" />}Evet, Taslak Kaydet
        </Button>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
